var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-act"},[_c('div',{staticClass:"btn-close",on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',[_c('img',{attrs:{"src":_vm.info.img},on:{"click":_vm.clickFloatPic}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }